import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'

Vue.config.productionTip = false

Vue.use(ElementUI)
/* eslint-disable no-new */

// 全局组件挂载
import TopBar from "./components/TopBar"
import Logo from "./components/Logo"
import CustomDialog from "./components/check"
Vue.component('TopBar', TopBar)
Vue.component('Logo', Logo)
Vue.component('CustomDialog', CustomDialog)

// element-ui的css样式要单独引入
import 'element-ui/lib/theme-chalk/index.css'

import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)
Vue.use(VueI18n)


// 国际化语言切换
export function getUserLanguage() {
  if (localStorage.getItem('lang')) {
    return localStorage.getItem('lang')
  }
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0]; // 返回用户的首选语言
  } else {
    return navigator.language || navigator.userLanguage; // 对于不支持 navigator.languages 的浏览器
  }
}
const lang = getUserLanguage().includes('fr') ? 'fr-FR' : 'en-US'


import {Locale} from "vant"
import enUS from 'vant/es/locale/lang/en-US'
import frFR from 'vant/es/locale/lang/fr-FR'
import el_enUS from 'element-ui/src/locale/lang/en'
import el_frFR from 'element-ui/src/locale/lang/fr'
import locale from 'element-ui/lib/locale'
Locale.use(lang, lang === 'fr-FR' ? frFR : enUS)
locale.use(lang === 'fr-FR' ? el_frFR : el_enUS)


import messages from '@/i18n'
export const i18n = new VueI18n({
  locale: lang,
  messages
})



// 创建应用
export const app = new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js